import * as React from 'react';

/**
 * Represent the state of a menu (including submenus).
 */
export type MenuState = {
    /**
     * Id of the current menu.
     */
    id: string;
    /**
     * The menu id that has the virtual focus.
     */
    focusedId: string | null;
    /**
     * Set the menu that has the virtual focus.
     */
    setFocusedId: React.Dispatch<React.SetStateAction<string | null>>;
    /**
     * Focus the menu (in this context).
     */
    focus: (options?: { closeSubmenu?: boolean }) => void;
};

/**
 * Menu state exposed as context.
 */
export const MenuStateContext = React.createContext<MenuState | null>(null);
